export const API_URL = (process.env.REACT_APP_API_URL || 'https://kisandailyfresh.in').replace(/\/+$/, '');

export const buildApiUrl = (path = '') => {
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedPath = String(path).replace(/^\/+/, '');
  return normalizedPath ? `${API_URL}/${normalizedPath}` : API_URL;
};

export const buildAssetUrl = (assetPath) => {
  if (!assetPath) return null;

  if (Array.isArray(assetPath)) {
    return assetPath.map(buildAssetUrl).find(Boolean) || null;
  }

  if (typeof assetPath === 'object') {
    const candidate =
      assetPath.url ??
      assetPath.image_url ??
      assetPath.product_image_url ??
      assetPath.image_path ??
      assetPath.path ??
      assetPath.src ??
      assetPath.image ??
      assetPath.product_image ??
      assetPath.file_path ??
      assetPath.filename ??
      null;
    return candidate ? buildAssetUrl(candidate) : null;
  }

  const normalizedPath = String(assetPath).trim();
  if (!normalizedPath) return null;

  if (normalizedPath.startsWith('[') && normalizedPath.endsWith(']')) {
    try {
      const parsed = JSON.parse(normalizedPath);
      if (Array.isArray(parsed)) return buildAssetUrl(parsed);
    } catch {
      // Keep the original string as a relative asset path if it is not JSON.
    }
  }

  if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;
  if (/^(data:|blob:)/i.test(normalizedPath)) return normalizedPath;
  return buildApiUrl(normalizedPath);
};
